import objectToFormData from "object-to-formdata";
import { Call, ApiUrl, ParseGeneralResponse } from "./ApiUtils";
import { ensureCompanyColumns, normalizeCompanyColumns } from "../helpers/common";

export function setGridConfigSetting(data) {
  let configValues = normalizeCompanyColumns(data.config_value);
       configValues = ensureCompanyColumns(configValues);
  const { config_type, config_value,organization_id,user_id,default_sort_by } = data;
  const url = ApiUrl(`v2/grid_configs/update_setting`);
  const formData = objectToFormData({  config_type, config_value: configValues, organization_id,user_id,...(default_sort_by && default_sort_by !== "" ? { default_sort_by } : {})
  });
  return Call("put", url, formData, ParseGeneralResponse);
}

export function fetchUserForDisp(orgId,userId) {
  const url = ApiUrl(
    `v2/grid_configs?organization_id=${orgId}&user_id=${userId}`
  );
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        configuration: "configuration",
      },
    },
  );
}
